module.exports = __webpack_public_path__ + "img/grade_C.d748b26.svg";